export class MeRightMailGlobal {
  menu: MeRightMailMenu;
  mails: MeRightMailMails[];
  iScan: MeRightMailIScan;
}

export interface MeRightMailMenu {
  aClasser: boolean;
  aCompleter: boolean;
  aCreer: boolean;
  aDistribuer: boolean;
  controleQualiteScan: boolean;
  malRoutes: boolean;
  priseEnCharge: boolean;
  scanningArchivage: boolean;
  signatureDocuments: boolean;
  validation: boolean;
  validationDocuments: boolean;
}

export interface MeRightMailMails {
  addFile: boolean;
  addMailEntrant: boolean;
  addMailInterne: boolean;
  addMailSortant: boolean;
  addVersionsFile: boolean;
  deleteFile: boolean;
  editFile: boolean;
  openFile: boolean;
  serviceId: number;
  viewFile: boolean;
  viewVersionsFile: boolean;
}

export interface MeRightMailIScan {
  limitFirstLevelService: boolean;
}
